import { createContext, useContext } from "react";

export interface SmoothScrollValue {
  scrollTo: (target: string | number, immediate?: boolean) => void;
}

export const SmoothScrollContext = createContext<SmoothScrollValue>({
  scrollTo: () => {},
});

export const useSmoothScroll = () => useContext(SmoothScrollContext);
